module.exports = __webpack_public_path__ + "2a94e8dfe3fbe750dc39b6e4434884c6.svg";